// extracted by mini-css-extract-plugin
module.exports = {"space--block":"Space_space--block__1SPOQ","justify--center":"Space_justify--center__cO6eh"};